import type { AchievementId } from '@h2h/shared';
import { Flame, Target, TrendingUp, Trophy } from '../../components/ui/icons';
import { cn } from '../../lib/cn';

const BADGE_STYLE: Record<AchievementId, { from: string; to: string; Icon: typeof Trophy }> = {
  EXACT_MASTER: { from: '#24C56A', to: '#08A079', Icon: Target },
  HOT_STREAK: { from: '#FF8A3D', to: '#E2541F', Icon: Flame },
  CLIMBER: { from: '#5B6EE1', to: '#33408F', Icon: TrendingUp },
  REACH_ELITE: { from: '#C9B8F0', to: '#7E5BD6', Icon: Trophy }
};

export function AchievementBadge({ id, label, earned }: { id: AchievementId; label: string; earned: boolean }) {
  const s = BADGE_STYLE[id];
  return (
    <div className="flex flex-col items-center gap-[7px]">
      <div
        style={earned ? { backgroundImage: `linear-gradient(150deg, ${s.from}, ${s.to})` } : undefined}
        className={cn(
          'grid aspect-square w-full place-items-center rounded-2xl',
          earned ? 'shadow-[0_10px_20px_-10px_rgba(10,150,110,0.5)]' : 'border border-dashed border-black/15 bg-fill2'
        )}
      >
        <s.Icon width={26} height={26} strokeWidth={2} className={earned ? 'text-white' : 'text-ink4'} />
      </div>
      <span className={cn('text-center text-[9px] font-bold leading-[1.1]', earned ? 'text-ink' : 'text-ink3')}>
        {label}
      </span>
    </div>
  );
}
